import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../api/axiosInstance";
import ResetPasswordForm from "../components/ResetPasswordForm";

function ResetPasswordPage() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: ""
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!formData.username.trim()) {
      newErrors.username = "اسم المستخدم مطلوب";
    }

    if (!formData.oldPassword) {
      newErrors.oldPassword = "كلمة المرور القديمة مطلوبة";
    } else if (formData.oldPassword.length < 6) {
      newErrors.oldPassword = "كلمة المرور يجب أن تكون 6 أحرف على الأقل";
    }

    if (!formData.newPassword) {
      newErrors.newPassword = "كلمة المرور الجديدة مطلوبة";
    } else if (formData.newPassword.length < 6) {
      newErrors.newPassword = "كلمة المرور الجديدة يجب أن تكون 6 أحرف على الأقل";
    }

    if (!formData.confirmNewPassword) {
      newErrors.confirmNewPassword = "تأكيد كلمة المرور الجديدة مطلوب";
    } else if (formData.newPassword !== formData.confirmNewPassword) {
      newErrors.confirmNewPassword = "كلمتا المرور غير متطابقتين";
    }

    // Optional: prevent setting same password
    if (
      formData.oldPassword &&
      formData.newPassword &&
      formData.oldPassword === formData.newPassword
    ) {
      newErrors.newPassword = "كلمة المرور الجديدة يجب أن تكون مختلفة عن القديمة";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));

    setErrors((prev) => ({
      ...prev,
      [e.target.name]: "",
      general: ""
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);

    try {
      // Placeholder endpoint - adjust later when you implement backend
      await axiosInstance.post("auth/reset-password", {
        username: formData.username,
        oldPassword: formData.oldPassword,
        newPassword: formData.newPassword
      });

      toast.success("تم تغيير كلمة المرور بنجاح ✅");
      navigate("/login");
    } catch (error) {
      if (error.response) {
        const status = error.response.status;

        if (status === 401) {
          setErrors({ general: "اسم المستخدم أو كلمة المرور القديمة خاطئة" });
          toast.error("فشل تغيير كلمة المرور ⚠️");
        } else if (status === 400) {
          setErrors({ general: "الرجاء التحقق من البيانات المدخلة" });
        } else {
          setErrors({ general: "حدث خطأ غير متوقع" });
          toast.error("حدث خطأ غير متوقع، حاول مرة أخرى ⚠️");
        }
      } else if (error.request) {
        toast.error("خطأ في الاتصال بالخادم ⚠️");
        setErrors({ general: "تعذر الاتصال بالخادم" });
      } else {
        toast.error("حدث خطأ غير متوقع، حاول مرة أخرى ⚠️");
        setErrors({ general: "حدث خطأ غير متوقع" });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ResetPasswordForm
      formData={formData}
      errors={errors}
      isSubmitting={isSubmitting}
      onChange={handleChange}
      onSubmit={handleSubmit}
      onBackToLogin={() => navigate("/login")}
    />
  );
}

export default ResetPasswordPage;